<template>

    <div class="product-search-selector">
        <transition
            enter-active-class="ease-out duration-300"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="ease-in duration-200"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <!-- Product Search Selector -->
            <div class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true" v-if="loaded">
                <div class="flex items-end justify-center sm:min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <div class="fixed inset-0 bg-gray-500 bg-opacity-60 transition-opacity" aria-hidden="true" @click="closeModal"></div>

                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                    <div class="inline-block bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all align-top mt-20 w-5/6 md:4/6 xl:w-1/2">
                        <div>
                            <div>
                                <div class="flex">
                                    <h3 class="flex-1 text-lg leading-6 font-medium text-gray-900" id="modal-title">
                                        Find a Product
                                    </h3>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-400 cursor-pointer" fill="none" viewBox="0 0 24 24" stroke="currentColor" @click="closeModal">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                                    </svg>
                                </div>

                                <p class="text-sm text-gray-400">
                                    Select or search for a product.
                                </p>
                                <div class="form-control mt-2">

                                    <form @submit.prevent="filterResults">
                                        <input :id="`find-product`" :name="`find-product`" type="text" class="relative " placeholder="Find a Product" autocomplete="off" v-model="query" @blur="filterResults" @keyup="delayedFilterResults">
                                    </form>

                                    <div class="absolute left-4 right-4 mb-8 mt-4 border-t-4 border-brand-500 bg-white shadow-xl px-4 py-5 sm:rounded-b-lg z-50 p-10" v-show="true">
                                        <div class="grid grid-cols-2 md:grid-cols-4 max-h-80 overflow-y-scroll">
                                            <ul class="px-4 py-1" v-for="product in products">
                                                <li class="cursor-pointer text-center" @click.prevent="selectProduct(product)">
                                                    <img :src="product.meta.image" class="w-32 h-20 mx-auto rounded shadow-md mb-4" alt="Missing Image" :title="`${product.name} (${product.sku})`">
                                                    <span class="text-sm text-gray-500 font-medium">{{ ellipsis(product.name, 20) }}</span><br>
                                                    <span class="text-xs text-gray-400">{{ product.sku }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Product Search Selector -->
        </transition>
    </div>

</template>

<script>
import Fuse from "fuse.js";
import {FormattingMixin} from "../../support/mixins";

export default {
    name: "ProductSearchSelector",
    mixins: [FormattingMixin],
    props: {
        data: {
            type: Array,
            required: true,
        },
        blur_timeout: {
            type: Number,
            required: false,
            default: 500
        },
        options: {
            type: Object,
            required: false,
            default: function () {
                return {
                    shouldSort: true,
                    includeScore: true,
                    threshold: 0.4,
                    keys: ['name','sku']
                }
            }
        }
    },
    data() {
        return {
            loaded: false,
            products: false,
            query: null,
            timeout: null,

        };
    },
    methods: {
        delayedFilterResults(event) {
            let vm = this;

            clearTimeout(vm.timeout);

            vm.timeout = setTimeout(function () {
                vm.filterResults(event);
            }, vm.blur_timeout);
        },
        filterResults() {
            let vm = this;

            new Promise(resolve => {
                clearTimeout(this.timeout);

                if (!vm.query || vm.query === '') {
                    return vm.products = vm.data;
                }

                let fuse = new Fuse(vm.data, vm.options);

                return vm.products = fuse.search(vm.query).map(r => r.item);

            }).then(result => {
                this.$emit('filterResults', result);
            });
        },
        closeModal() {
            this.$emit('closeModal');
        },
        selectProduct(product) {
            this.$emit('selectProduct', product);
        }
    },
    mounted() {
        let vm = this;

        new Promise(resolve => {
            vm.products = vm.data;

            resolve(true);
        }).then(result => {
            vm.loaded = result;
        })
    }
}
</script>
